/**
 * Reports Core Web Vitals metrics to the provided callback.
 * Measures CLS, FID, FCP, LCP, and TTFB for performance monitoring.
 * @param {Function} onPerfEntry - Callback function to receive performance metrics
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
